import Signup from '@klv/organisms/form/signup';

import type { ISignupFormProps } from '../../types';
import type { ISignup } from '@klv/organisms/form/types';

export const SignupForm = ({
  embeddedForm,
  backgroundColor,
  embeddedFormBodyCopy,
  formState,
  embeddedFormHeadline,
  setFormState,
  showAgencyFields,
  fullWidth,
}: ISignupFormProps) => {

  const signupFormProps: ISignup = {
    backgroundColor,
    bodyCopy: embeddedFormBodyCopy,
    formState,
    headline: embeddedFormHeadline,
    inHero: true,
    setFormState,
    templateName: 'Default',
    showAgencyFields,
    fullWidth,
  };

  if (embeddedForm === 'signupTwoColumn') {
    signupFormProps.layout = 'twoColumn';
  }

  if (embeddedForm === 'signupSimple') {
    signupFormProps.layout = 'simple';
  }

  if (embeddedForm === 'signupInvisibleReCaptcha') {
    signupFormProps.recaptchaInstance = 'invisible';
  }

  if (embeddedForm === 'signupTest') {
    signupFormProps.buttonPlacementDecision = true;
  }

  return <Signup {...signupFormProps} />;
}
